const data = [
    {
        id: 'piaf',
        icon: 'font-simpleicons simple-icon-home',
        label: 'Dashboard',

        subs: [
            {
                icon: 'font-simpleicons simple-icon-home',
                // label: "menu.start",
                label: 'Dashboard',
                to: `/dashboard/start`,
                // roles: [UserRole.Admin, UserRole.Editor],
            },
            {
                icon: 'font-iconsmind iconsminds-calendar-1',
                label: 'Personal-Events',
                to: `/dashboard/personalevent`,
            },
            {
                icon: 'font-iconsmind iconsminds-telephone-2',
                // label: "menu.start",
                label: 'Telefonliste',
                to: `/dashboard/telefonliste`,
                // roles: [UserRole.Admin, UserRole.Editor],
            },
            {
                icon: 'font-iconsmind iconsminds-green-house',
                // label: "menu.start",
                label: 'Niederlassungen',
                to: `/dashboard/niederlassungen`,
                // roles: [UserRole.Admin, UserRole.Editor],
            },

            {
                icon: 'font-iconsmind iconsminds-watch',
                // label: "menu.start",
                label: 'Zeitkonto Alt',
                to: `/dashboard/arbeitszeitkonto`,
                // roles: [UserRole.Admin, UserRole.Editor],
            },

            {
                icon: 'font-iconsmind iconsminds-envelope',
                // label: "menu.start",
                label: 'Mailing',
                to: `/dashboard/mailing`,
                /*subs: [{
    icon: "iconsminds-forsquare",
    label: "Metall",
    to: `/dashboard/mailing/metall`
  },
  {
    icon: "iconsminds-chemical",
    label: "Chemie",
    to: `/dashboard/mailing/chemie`
  },


  ]*/
                // roles: [UserRole.Admin, UserRole.Editor],
            },
        ],
    },
    {
        id: 'second-menu',
        icon: 'font-iconsmind iconsminds-statistic',
        label: 'Statistiken',

        subs: [
            {
                icon: 'font-iconsmind iconsminds-consulting',
                label: 'Vertrieb',
                to: `/statistiken/vertriebsstatistik`,
            },
            {
                icon: 'font-iconsmind iconsminds-target-market',
                label: 'Vertrieb Übersicht',
                to: `/statistiken/vertriebuebersicht`,
            },
            {
                icon: 'font-iconsmind iconsminds-box-with-folders',
                label: 'Vertriebsvergleich',
                to: `/statistiken/vertriebsvergleich`,
            },
            {
                icon: 'font-iconsmind iconsminds-first-aid',
                label: 'Unfall',
                to: `/statistiken/unfall`,
            },
            {
                icon: 'font-iconsmind iconsminds-line-chart-1',
                label: 'Produktivität',
                to: `/statistiken/produktiv`,
            },
            {
                icon: 'font-iconsmind iconsminds-stethoscope',
                label: 'Werksarztzentrum',
                to: `/statistiken/werksarztzentrum`,
            },
            {
                icon: 'font-simpleicons simple-icon-user',
                label: 'Personal',
                to: `/statistiken/personal`,
            },
            {
                icon: 'font-iconsmind iconsminds-check',
                label: 'Audits Prüfliste',
                to: `/statistiken/pruefliste`,
            },
            {
                icon: 'font-iconsmind iconsminds-delete-file',
                label: 'Audits Fehlerliste',
                to: `/statistiken/pruefliste_fehlerliste`,
            },
        ],
    },

    {
        id: 'notshow_main',
        icon: 'font-simpleicons simple-icon-people',
        label: 'Intern',

        subs: [
            {
                icon: 'font-simpleicons simple-icon-calendar',
                label: 'Events',
                to: `/intern/event`,
                // id:"notshow2"
            },
            {
                icon: 'font-simpleicons simple-icon-user-following',
                label: 'Personalabteilung',
                to: `/intern/PersonalAbteilung`,
                //id:"notshow"
            },
            {
                icon: 'font-iconsmind iconsminds-business-man-woman',
                label: 'Personalübersicht',
                to: `/intern/Personaluebersicht`,
                //id:"notshow1"
            },
            /*  {
    icon: "simple-icon-support",
     label:"Niederlassungen",
     to: `/intern/intern-niederlassung`,
   } */
        ],
    },

    {
        id: 'digital-menu',
        icon: 'font-iconsmind iconsminds-laptop---phone',
        label: 'Digital-Status',

        subs: [
            {
                label: 'Ziel',
                subs: [
                    {
                        id: 'show_ziel',
                        icon: 'iconsminds-conference',
                        label: 'Bundeseinheitlich',
                        to: `/digital/Bundeseinheitlich`,
                    },
                    {
                        icon: 'iconsminds-communication-tower-2',
                        label: 'Elektronische Anfragen',
                        to: `/digital/Elektronischeanfrage`,
                    },
                ],
            },
            {
                id: 'myTempton',
                label: 'myTempton',

                subs: [
                    {
                        icon: 'font-simpleicons simple-icon-trophy',
                        label: 'Betriebsliga',
                        to: `/digital/Betriebsliga`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-smartphone-3',
                        label: 'Aktivierung',
                        to: `/digital/Aktivierung`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-billing',
                        label: 'Abrechnung',
                        to: `/digital/Lohnabrechnung`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-cursor-select',
                        label: 'Nutzung',
                        to: `/digital/myTempton-Nutzung`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-over-time-2',
                        label: 'Zeiterfassung',
                        to: `/digital/myTempton-zeiterfassung`,
                    },
                    {
                        id: 'transponder',
                        icon: 'font-simpleicons simple-icon-clock',
                        label: 'Zeiterfassung-GF',
                        to: `/digital/myTempton-Transponder`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-palm-tree',
                        label: 'Urlaub',
                        to: `/digital/myTempton-urlaub`,
                    },
                ],
            },
            {
                id: 'Temptoncheckin',
                label: 'Tempton check-in',

                subs: [
                    {
                        icon: 'font-iconsmind iconsminds-tablet-3',
                        label: 'Bewerbertablets',
                        to: `/digital/bewerber-Tablets`,
                    },
                ],
            },
            {
                id: 'Bewerberlifecycle',
                label: 'Bewerber Lifecycle',

                subs: [
                    {
                        icon: 'font-iconsmind iconsminds-file-clipboard-file---text',
                        label: 'Übersicht',
                        to: `/digital/bewerber_Uebersicht`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-repeat-2',
                        label: 'Bewerber Status',
                        to: `/digital/bewerber_Status`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-add-user',
                        label: 'Bewerbung',
                        to: `/digital/bewerber-Mitarbeiter_bewerbung`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-handshake',
                        label: 'Einstellung',
                        to: `/digital/bewerber-Mitarbeiter_Einstell`,
                    },
                    {
                        icon: 'font-iconsmind iconsminds-male-female',
                        label: 'Mitarbeiter',
                        to: `/digital/bewerber-Mitarbeiter`,
                    },
                ],
            },
            {
                id: 'Tempton_connect',
                label: 'Tempton Connect',

                subs: [
                    {
                        icon: 'font-simpleicons simple-icon-event',
                        label: 'Event',
                        to: `/digital/tempton-connect-event`,
                    },
                ],
            },
        ],
    },
       {
        id: 'arbeitsplatz',
        icon: 'font-simpleicons  iconsminds-edit-map',
        label: 'Arbeitsplatz',
        subs: [
            {
                icon: 'font-simpleicons iconsminds-profile',
                label: 'Besichtigung',
                to: `/arbeitsplatz/besichtigung`,
            },
        ],
    },
    {
        id: 'fuhrpark',
        icon: 'font-iconsmind iconsminds-jeep',
        label: 'Fuhrpark',

        subs: [
            {
                icon: 'font-iconsmind iconsminds-car',
                label: 'Fuhrpark Informationen',
                to: `/fuhrpark/fuhrparkinfo`,
            },
        ],
    },
   /* {
        id: 'single',
        icon: 'font-simpleicons simple-icon-envelope',
        label: 'Kontakt',
        to: `/kontakt`,
    },*/
 
];
export default data;
